// `name` is what New Relic groups errors by, so a dedicated name lets booking-flow failures be filtered apart from generic `Error`s and from Stripe/Auth errors.
export default class BookingError extends Error {
  constructor(message = 'Booking error', options?: ErrorOptions) {
    super(message, options);
    this.name = 'BookingError';
  }
}
